import { ComponentType, useEffect, useRef } from 'react';
import { MenuProps, components } from 'react-select';
import styled, { createGlobalStyle } from 'styled-components';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { SelectOption } from '../../types';

// https://github.com/styled-components/styled-components/issues/2113#issuecomment-730411620
const MenuStyle = styled.div``;
const GlobalMenuStyle = createGlobalStyle<{ $dropdownSize: DropdownSize }>`
  ${MenuStyle} {
    && {
      box-shadow: none;
      z-index: 7; /* 7 is enough to cover the horizontal scroll bar in the gremlin code editor */
    }
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

const usePreventScroll = (preventScroll = true) => {
  const scrollBlocked = useRef<boolean>(false);
  const html = document.documentElement;
  const { body } = document;

  const blockScroll = () => {
    if (!body || !body.style || scrollBlocked.current) return;

    const scrollBarWidth = window.innerWidth - html.clientWidth;
    const bodyPaddingRight =
      parseInt(
        window.getComputedStyle(body).getPropertyValue('padding-right'),
        10
      ) || 0;

    // Don't apply position and overflow to `html` element:
    // It makes surveys layout jump to the top (ARD-14618)
    //
    // html.style.position = 'relative';
    // html.style.overflow = 'hidden';
    body.style.position = 'relative';
    body.style.overflow = 'hidden';
    body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

    scrollBlocked.current = true;
  };

  const allowScroll = () => {
    if (!body || !body.style || !scrollBlocked.current) return;

    // html.style.position = '';
    // html.style.overflow = '';
    body.style.position = '';
    body.style.overflow = '';
    body.style.paddingRight = '';

    scrollBlocked.current = false;
  };

  useEffect(() => {
    if (preventScroll) {
      blockScroll();
    }
    return () => allowScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preventScroll]);
};

export const Menu: ComponentType<
  MenuProps<SelectOption<unknown>> & {
    selectProps: { preventBodyScroll?: boolean; onBackdropClick?: () => void };
  }
> = props => {
  usePreventScroll(props.selectProps.preventBodyScroll);
  return (
    <>
      <GlobalMenuStyle $dropdownSize={DropdownSize.FULL_WIDTH} />
      {props.selectProps.preventBodyScroll && (
        <Backdrop onClick={props.selectProps.onBackdropClick} />
      )}
      <components.Menu {...props} className={MenuStyle.styledComponentId}>
        {props.children}
      </components.Menu>
    </>
  );
};
